
window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.moment = require('moment-timezone');
window.numeral = require('numeral');

import Echo from "laravel-echo"

window.Pusher = require('pusher-js');

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: EnvVars.pusher.key,
    cluster: EnvVars.pusher.cluster,
    forceTLS: true,
    authEndpoint: '/common/laravel-echo/auth'
});

sessionStorage.windowToken = EnvVars.session.id;
